import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import FormItem from '../../../components/form/FormItem'
import { MdTitle } from 'react-icons/md'
import { BiX } from 'react-icons/bi'
import { Button, Form } from 'reactstrap'
import { ToSeoUrl } from '../../../components/general/SeoUrl'
import { fetchFormGet } from '../../../redux/slices/formGetSlice'
import { fetchFormCreate } from '../../../redux/slices/formCreateSlice'
import { fetchFormUpdate } from '../../../redux/slices/formUpdateSlice'

const CrudForms = ({ showMenu, setShowMenu, formGroupId, languages, setChanged, setSelectedItem, selectedItem, t }) => {
    const [formData, setFormData] = useState({ files: [], formGroupId: 0 })
    const dispatch = useDispatch()

    const getData = async () => {
        if (selectedItem !== 0) {
            var data = await dispatch(fetchFormGet({ id: selectedItem }))
            if (data.payload) {
                var value = data.payload?.title
                var newFormData = { ...formData }
                languages.forEach(item => {
                    newFormData[`title${item.code}`] = value[item.code]
                    newFormData[`slug${item.code}`] = ToSeoUrl(value[item.code])
                    newFormData[`description${item.code}`] = data.payload?.description[item.code]
                    newFormData[`content${item.code}`] = data.payload?.content[item.code]
                });
                setFormData(newFormData)
            }
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const title = {}
        const slug = {}
        const description = {}
        const content = {}
        languages.forEach(item => {
            title[item.code] = formData[`title${item.code}`] ?? ""
            slug[item.code] = ToSeoUrl(formData[`title${item.code}`]) ?? ""
            description[item.code] = formData[`description${item.code}`] ?? ""
            content[item.code] = formData[`content${item.code}`] ?? ""
        });

        await dispatch(
            selectedItem === 0 ?
                fetchFormCreate({ file: formData.files, title: title, slug: slug, description: description, content: content, formGroupId: formGroupId }) :
                fetchFormUpdate({ id: selectedItem, file: formData.files, title: title, slug: slug, description: description, content: content, formGroupId: formGroupId })
        )
        setFormData({ files: [], formGroupId: 0 })
        setChanged(true)
        getData()
        setShowMenu(false)
    }

    const closeModal = () => {
        setFormData({ files: [], formGroupId: 0 })
        setShowMenu(!showMenu)
        setSelectedItem(0)
    }

    useEffect(() => { getData() }, [dispatch, selectedItem])

    return (
        <div className={showMenu ? 'right-popup' : 'd-none'}>
            <div className='right-popup-close' onClick={closeModal}><BiX size={24} /></div>
            <div className='right-popup-menu'>
                <div className='mb-3 text-center'><h5>{t(selectedItem === 0 ? "form_add" : "form_edit")}</h5></div>
                <Form onSubmit={handleSubmit}>
                    {
                        languages?.map((item, index) => {
                            return (
                                <FormItem
                                    key={index}
                                    id={`title${item?.code}`}
                                    name={`title${item?.code}`}
                                    type="text"
                                    icon={<MdTitle size={20} />}
                                    title={`${t("title")} (${item?.code.toUpperCase()})`}
                                    formData={formData}
                                    setFormData={setFormData}
                                    keyT={`title${item?.code}`}
                                />
                            )
                        })
                    }

                    <div className='d-flex justify-content-end mt-4 w-100'>
                        <Button type='submit' color={selectedItem === 0 ? 'primary' : 'warning'} className="text-white">
                            {t(selectedItem === 0 ? "add" : "edit")}
                        </Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default CrudForms
